module.exports = __webpack_public_path__ + "web-assets/img/status.17b976f0.png";